import { render, staticRenderFns } from "./BaseArticleIframeRow.vue?vue&type=template&id=48f97782&scoped=true&"
import script from "./BaseArticleIframeRow.vue?vue&type=script&lang=js&"
export * from "./BaseArticleIframeRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticleIframeRow.vue?vue&type=style&index=0&id=48f97782&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f97782",
  null
  
)

export default component.exports